import {requestFetch} from './Autobatcher';
import {getModelManager, ManagedModelTypes} from './ManagedModelDefinitions';

/**
 * Top-level code for async-fetching a managed model. This can be called repeatedly and fetching
 * will be done intelligently: we won't fetch something we're already fetched or in the process of
 * being fetched, multiple fetch operations in the same tick will be coalesced, and fetching can be
 * done even in functions like render and mapStateToProps.
 */
export function requestFetchManagedModel(modelType: keyof ManagedModelTypes, key: string): void {
  requestFetch(getModelManager(modelType), key);
}

export function forceFetchManagedModel(modelType: keyof ManagedModelTypes, key: string): void {
  requestFetch(getModelManager(modelType), key, {forceFetch: true});
}
